import React, { FC, ReactNode, useMemo } from 'react';
import { ColumnWidth } from 'modules/core/enums';

import { FormLabel, FormRow as FormRowUI, SubLabel, ColUI as Col, AISparkles } from './styles';

interface IFormRow {
  required?: boolean;
  label?: string;
  control: ReactNode;
  disabled?: boolean;
  fieldWidth?: ColumnWidth | string;
  subLabel?: string;
  isVerticalAlign?: boolean;
  name?: string;
  boldLabel?: boolean;
  inputPaddingLeft?: number;
  labelWithoutAsterisk?: boolean;
  showAISparkles?: boolean;
}

export const FormRow: FC<IFormRow> = ({
  control,
  label,
  required,
  disabled,
  fieldWidth,
  subLabel,
  isVerticalAlign,
  name,
  boldLabel,
  inputPaddingLeft = undefined,
  labelWithoutAsterisk = false,
  showAISparkles = false,
}) => {
  const colWidths = useMemo(() => {
    if (fieldWidth === 'adjustDeal') {
      return {
        disableMargin: true,
        label: ColumnWidth.FULL,
        control: ColumnWidth.PRE_FULL,
      };
    }

    if (isVerticalAlign) {
      return { label: ColumnWidth.FULL, control: ColumnWidth.FULL };
    }

    const controlCol = label ? (fieldWidth as ColumnWidth) || ColumnWidth.S : ColumnWidth.FULL;
    const labelCol = ColumnWidth.FULL - controlCol;

    return { label: labelCol, control: controlCol };
  }, [fieldWidth, isVerticalAlign, label]);

  return (
    <FormRowUI>
      {label && (
        <Col id={name && name.substr(name.indexOf('.') + 1)} xs={colWidths.label}>
          <FormLabel
            required={required}
            disabled={disabled}
            bold={boldLabel}
            labelWithoutAsterisk={labelWithoutAsterisk}
          >
            {label}
            {showAISparkles && <AISparkles />}
            {subLabel && <SubLabel>{subLabel}</SubLabel>}
          </FormLabel>
        </Col>
      )}
      <Col xs={colWidths.control} $inputPaddingLeft={inputPaddingLeft} $disableMargin={colWidths.disableMargin}>
        {control}
      </Col>
    </FormRowUI>
  );
};
